import useAuth from '@/api/auth';

const { isLoggedIn } = useAuth();

export async function notLoggedIn({ next, nextMiddleware }) {
  if (isLoggedIn.value) {
    return next({
      name: 'devices'
    });
  }
  return nextMiddleware();
}
